import { DEMO_CALCULATOR_STEP } from 'config/constants'
import {
  DEMO_STEP_DELAY,
  DEMO_STEP_PLAYBACK_COMPLETE_EVENT,
} from '../../playback-constants'
import {
  animateAction,
  scrollToCustomsAction,
  wait,
  waitForDocumentElement,
} from '../../helpers'

export const playCustomsStep = async ({
  controls,
  fields,
  stepElement,
}: PlayCustomsStepParams) => {
  const fieldsAreTyped = await controls.typeFields(fields)

  if (!fieldsAreTyped) {
    controls.clearFields(fields)
    return false
  }

  const action = stepElement.querySelector<HTMLElement>(
    '[data-demo-playback-action="save-customs"]',
  )

  if (!action) {
    return false
  }

  controls.setActiveFieldElement(null)

  if (!stepElement.closest('.demo-player')) {
    await wait(DEMO_STEP_DELAY * 3)
  }

  const hasReachedAction = await scrollToCustomsAction(action, controls.isCancelled)

  if (!hasReachedAction) {
    return false
  }

  await animateAction(action, false)
  action.click()

  if (!stepElement.closest('.demo-player')) {
    const nextStepAction = await waitForDocumentElement(
      '[data-demo-playback-action="certification"]',
      controls.isCancelled,
    )

    if (!nextStepAction) {
      return false
    }
  }

  return controls.dispatchEvent(new CustomEvent(DEMO_STEP_PLAYBACK_COMPLETE_EVENT, {
    detail: { step: DEMO_CALCULATOR_STEP.CUSTOMS },
  }))
}
